import React from "react";
import { useSelector } from "react-redux";
import ProductListCard from "./ProductListCard";

const TrendingProducts = () => {
  const { trendingProducts } = useSelector((state) => state.product);

  return (
    <>
      {trendingProducts && trendingProducts?.length > 0 && (
        <div
          className="col-xl-3 col-lg-4 col-md-6 mb-md-0 wow animate__animated animate__fadeInUp"
          data-wow-delay=".1s"
        >
          <h4 className="section-title style-1 mb-30 animated animated">
            Trending Products
          </h4>
          <div className="product-list-small animated animated">
            {trendingProducts?.map((item, index) => (
              <ProductListCard key={index} item={item} />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default TrendingProducts;
